module.exports = __webpack_public_path__ + "static/media/background-service.4e9894a7.svg";